import React from 'react';
import { Asset } from '@src/components/generated/graphql';
import { formatsMarketplaceNft } from '@src/components/side-bar-menu/nft-assets/nft-types';
import cardStyle from '../../side-bar-menu/nft-assets/nft-assets-card.module.css';

type Props = {
  data: Asset;
  callback: Function;
};

const AssetCard: React.FC<Props> = ({ data, callback }) => {
  const loadAsset = (type: Asset['fileType']) => {
    callback(data.name, data.assetURL, formatsMarketplaceNft[type], data.id);
  };

  return (
    <div className={cardStyle.card} onClick={() => loadAsset(data.fileType)}>
      <img
        className={cardStyle.previewImage}
        src={data.fileType === 'IMAGE' ? data.assetURL : data.previewImage}
        alt={'Nft image.'}
      />
      <span className={cardStyle.name}>{data.name}</span>
    </div>
  );
};

export default AssetCard;
